/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type IntegrationCreateCreditPayload = {
    categoryId: number;
    totalCredits: number;
    source: IntegrationCreateCreditPayload.source;
    validUntil?: string | null;
    note?: string | null;
};
export namespace IntegrationCreateCreditPayload {
    export enum source {
        PACKAGE = 'package',
        AGREEMENT = 'agreement',
        PRO_BONO = 'pro_bono',
        OTHER = 'other',
    }
}

